import { useMemo } from "react";

import { useMessengerStoreMainStreamFetchState } from "./useMessengerStoreMainStreamFetchState";

export const useMessengerStoreConversationStorage = () => {
  const { mainStreamFetchState } = useMessengerStoreMainStreamFetchState();

  const conversationByUserToken = mainStreamFetchState?.conversationByUserToken;
  const conversationByBrandToken =
    mainStreamFetchState?.conversationByBrandToken;
  const conversationByRetailerToken =
    mainStreamFetchState?.conversationByRetailerToken;
  const conversationByConversationToken =
    mainStreamFetchState?.conversationByConversationToken;

  return useMemo(
    () => ({
      conversationByUserToken,
      conversationByBrandToken,
      conversationByRetailerToken,
      conversationByConversationToken,
    }),
    [
      conversationByBrandToken,
      conversationByConversationToken,
      conversationByRetailerToken,
      conversationByUserToken,
    ]
  );
};
